import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from 'pinia'
import { computed, getCurrentInstance, ref } from 'vue'

import Icon from '@/client/components/_atoms/Icon.vue'
import CampaignCreateAccount from '@/client/components/_organisms/CampaignCreateAccount.vue'
import CampaignCreateInstagramCondition from '@/client/components/_organisms/CampaignCreateInstagramCondition.vue'
import CampaignCreatePeriod from '@/client/components/_organisms/CampaignCreatePeriod.vue'
import CampaignCreateTitle from '@/client/components/_organisms/CampaignCreateTitle.vue'
import { useCampaignDialogStore } from '@/client/store/useCampaignDialogStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'DialogInstagramCampaignEdit',
  emits: ["campaignUpdated"],
  setup(__props, { expose, emit }: { emit: ({ (e: 'campaignUpdated'): void }), expose: any, slots: any, attrs: any }) {

const visible = ref(false)

const campaignDialogStore = useCampaignDialogStore()
const { is_form_change, is_edit_disabled } = storeToRefs(campaignDialogStore)

// getters (computed)
const isFormChange = computed(() => is_form_change.value)
const isEditDisabled = computed(() => is_edit_disabled.value)

// actions
const setCampaignId = (id: number) => campaignDialogStore.setCampaignId(id)
const fetchCampaign = () => campaignDialogStore.fetchCampaign()
const fetchCampaignAccounts = () => campaignDialogStore.fetchCampaignAccounts()
const updateCampaign = () => campaignDialogStore.updateCampaign()
const deleteCampaign = () => campaignDialogStore.deleteCampaign()
const setMode = (mode: 'create' | 'edit' | 'copy') => campaignDialogStore.setMode(mode)
const reset = () => campaignDialogStore.reset()

// 通知処理がvue2のため、anyで補完
const { proxy } = getCurrentInstance() as any

// 親コンポーネントイベント通知


/**
 * ダイアログを開く（Instagramキャンペーン編集用）
 */
async function open(campaignId: number) {
  await setCampaignId(campaignId)
  await setMode('edit')
  const response = await fetchCampaign()

  if (!response.data) {
    proxy.$notify({
      title: 'キャンペーンの取得に失敗しました。',
      message: '恐れ入りますが、時間をおいて再度お試しください。',
      customClass: 'danger'
    })

    visible.value = false
    await reset()
    return
  }

  await fetchCampaignAccounts()

  visible.value = true
}

/**
 * ダイアログキャンペーンを閉じる
 */
function handleClose() {
  if (!isFormChange.value) {
    visible.value = false
    reset()
    return
  }

  const confirm = window.confirm('編集内容が保存されていません。ダイアログを閉じますか？')

  if (!confirm) {
    return
  }

  visible.value = false
  reset()
}

/**
 * 保存ボタン
 */
async function onSave() {
  const result = await updateCampaign()

  if (result.error && result.error.type === 'MAX_CAMPAIGN_COUNT_OVER') {
    return proxy.$notify({
      title: 'キャンペーンの変更に失敗しました。',
      message: '同時開催可能件数を超えるため、指定の期間ではキャンペーンを開催できません。',
      customClass: 'danger'
    })
  }
  if (!result.data) {
    return proxy.$notify({
      title: 'キャンペーンの変更に失敗しました。',
      message: '恐れ入りますが、時間をおいて再度お試しください。',
      customClass: 'danger'
    })
  }

  proxy.$notify({
    title: 'キャンペーンを変更しました。',
    customClass: 'success'
  })

  // キャンペーン一覧の更新を親コンポーネントに通知
  emit('campaignUpdated')

  visible.value = false
  reset()
}

/**
 * 削除ボタン
 */
async function onDelete() {
  const confirm = window.confirm('キャンペーンを削除してよろしいですか？')

  if (!confirm) {
    return
  }

  const result = await deleteCampaign()

  if (result.error && result.error.type === 'NO_DATA_EXISTS') {
    return proxy.$notify({
      title: '対象のキャンペーンはすでに削除されています。',
      customClass: 'danger'
    })
  }

  if (!result.data) {
    return proxy.$notify({
      title: 'キャンペーンの削除に失敗しました。',
      customClass: 'danger'
    })
  }

  // キャンペーン一覧の更新を親コンポーネントに通知
  emit('campaignUpdated')

  proxy.$notify({
    title: 'キャンペーンを削除しました。',
    customClass: 'success'
  })

  visible.value = false
  reset()
}

expose({ open, handleClose })

return { __sfc: true,visible, campaignDialogStore, is_form_change, is_edit_disabled, isFormChange, isEditDisabled, setCampaignId, fetchCampaign, fetchCampaignAccounts, updateCampaign, deleteCampaign, setMode, reset, proxy, emit, open, handleClose, onSave, onDelete, Icon, CampaignCreateAccount, CampaignCreateInstagramCondition, CampaignCreatePeriod, CampaignCreateTitle }
}

})